import * as React from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";

import * as actions from "../../../../actions/actions";
import AppTile from "./app-tile";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { MappedThunk } from "actions/action-thunk";
import { openTemplates } from "designer/lib/url-utils";
import { appAutoPublish } from "routes";
import { Icon } from "common/render/icon";
import { trackEvent } from "analytics";
import { BuilderTheme } from "sharedUI/styles";
import { Badge } from "designer/ui/views/badge/badge";

interface Props extends RouteComponentProps {
    readonly theme: BuilderTheme;
    readonly name: string;
    readonly templateID: string | undefined;
    readonly targetOwnerID: string | undefined;
    readonly color: string;
    readonly icon: string;
    readonly isProTrial: boolean;
    readonly copySampleApp: MappedThunk<typeof actions.copySampleApp>;
}

interface State {
    readonly copyingTemplate: boolean;
}

class TemplateAppTileImpl extends React.PureComponent<Props, State> {
    public state: State = {
        copyingTemplate: false,
    };

    private onClick = async () => {
        const { templateID, copySampleApp, history, targetOwnerID, isProTrial } = this.props;
        if (templateID === undefined) {
            trackEvent("browse templates from builder", { user_id: targetOwnerID ?? "" });
            openTemplates();
        } else {
            this.setState({ copyingTemplate: true });
            trackEvent("copy builder template", { user_id: targetOwnerID ?? "", isProTrial });
            await copySampleApp(
                templateID,
                appID => {
                    if (appID === undefined) return;
                    history.push(appAutoPublish(appID));
                },
                true,
                targetOwnerID
            );
            this.setState({ copyingTemplate: false });
        }
    };

    public render(): React.ReactNode {
        const { name, icon, color, isProTrial } = this.props;
        const { copyingTemplate } = this.state;

        const content = (
            <div style={{ position: "relative" }}>
                <Icon
                    size={64}
                    clipCorners={true}
                    color={color}
                    image={{ url: `/images/${icon}.svg` }}
                    inset
                    lightGradientOverlay
                />
                {isProTrial && (
                    <Badge position={true} distance="-5px">
                        PRO
                    </Badge>
                )}
            </div>
        );

        return (
            <AppTile
                name={name}
                dimBackground={true}
                canHover={true}
                onClick={this.onClick}
                isEnabled={!copyingTemplate}
                accentColor={color}>
                {content}
            </AppTile>
        );
    }
}

const mapDispatch = {
    copySampleApp: actions.copySampleApp,
};

const TemplateAppTile = connect(undefined, mapDispatch)(withRouter(withTheme(TemplateAppTileImpl)));
export default TemplateAppTile;
